/* ── Admin UI Base Utilities ── */

export function showToast(msg, isError = false) {
  const toast = document.getElementById('toast');
  if (!toast) return;
  toast.textContent = msg;
  toast.className = `toast show ${isError ? 'error' : 'success'}`;
  // Estilos rápidos para asegurar visibilidad si el CSS falla
  toast.style.background = isError ? 'rgba(255,45,85,0.2)' : 'rgba(0,255,136,0.2)';
  setTimeout(() => toast.classList.remove('show'), 2500);
}

export function showConfirm(msg, onOk, title = '¿CONFIRMAR?') {
  const modal = document.getElementById('confirm-modal');
  if (!modal) {
    // Si no existe el modal en el DOM, lo creamos una sola vez
    const newModal = document.createElement('div');
    newModal.id = 'confirm-modal';
    newModal.className = 'confirm-overlay hidden';
    newModal.innerHTML = `
      <div class="confirm-card">
        <h3 id="confirm-title"></h3>
        <p id="confirm-msg"></p>
        <div class="confirm-actions">
          <button id="confirm-cancel" class="btn-secondary">NO</button>
          <button id="confirm-ok" class="btn-primary">SÍ</button>
        </div>
      </div>`;
    document.body.appendChild(newModal);
    document.getElementById('confirm-cancel').onclick = () => newModal.classList.add('hidden');
  }
  
  const targetModal = document.getElementById('confirm-modal');
  document.getElementById('confirm-title').textContent = title;
  document.getElementById('confirm-msg').textContent = msg;
  targetModal.classList.remove('hidden');
  
  document.getElementById('confirm-ok').onclick = () => {
    targetModal.classList.add('hidden');
    if (onOk) onOk();
  };
}

export function escHtml(str) {
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

// Global backdrop handler
document.addEventListener('click', (e) => {
  const modals = ['video-modal', 'channel-modal', 'preview-modal', 'search-modal', 'confirm-modal'];
  modals.forEach(id => {
    const el = document.getElementById(id);
    if (el && e.target === el) {
      if (id === 'preview-modal') closePreview();
      else if (id === 'search-modal') closeYTSearch();
      else el.classList.add('hidden');
    }
  });
});
